"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRegisterNurseAccountV2Dto = instanceOfRegisterNurseAccountV2Dto;
exports.RegisterNurseAccountV2DtoFromJSON = RegisterNurseAccountV2DtoFromJSON;
exports.RegisterNurseAccountV2DtoFromJSONTyped = RegisterNurseAccountV2DtoFromJSONTyped;
exports.RegisterNurseAccountV2DtoToJSON = RegisterNurseAccountV2DtoToJSON;
exports.RegisterNurseAccountV2DtoToJSONTyped = RegisterNurseAccountV2DtoToJSONTyped;
const State_1 = require("./State");
const PhoneNumberCreateDto_1 = require("./PhoneNumberCreateDto");
/**
 * Check if a given object implements the RegisterNurseAccountV2Dto interface.
 */
function instanceOfRegisterNurseAccountV2Dto(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('homeState' in value) || value['homeState'] === undefined)
        return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined)
        return false;
    return true;
}
function RegisterNurseAccountV2DtoFromJSON(json) {
    return RegisterNurseAccountV2DtoFromJSONTyped(json, false);
}
function RegisterNurseAccountV2DtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'homeState': (0, State_1.StateFromJSON)(json['homeState']),
        'phoneNumber': (0, PhoneNumberCreateDto_1.PhoneNumberCreateDtoFromJSON)(json['phoneNumber']),
        'howDidYouHearAboutUs': json['howDidYouHearAboutUs'] == null ? undefined : json['howDidYouHearAboutUs'],
    };
}
function RegisterNurseAccountV2DtoToJSON(json) {
    return RegisterNurseAccountV2DtoToJSONTyped(json, false);
}
function RegisterNurseAccountV2DtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'homeState': (0, State_1.StateToJSON)(value['homeState']),
        'phoneNumber': (0, PhoneNumberCreateDto_1.PhoneNumberCreateDtoToJSON)(value['phoneNumber']),
        'howDidYouHearAboutUs': value['howDidYouHearAboutUs'],
    };
}
//# sourceMappingURL=RegisterNurseAccountV2Dto.js.map